import React, { useState } from 'react';

import { FormattedMessage } from 'react-intl';
import Alert from '~/ui/components/Alert/Alert';
import Box from '~/ui/components/Box/Box';
import Text from '~/ui/components/Text/Text';

export const EXPORT_EXCEL_LIMIT = 1000000;

const ExportExcelLimitWarning = ({ resultCount }) => {
  const [showAlert, setShowAlert] = useState(true);

  return showAlert && resultCount > EXPORT_EXCEL_LIMIT ? (
    <Box mb={4}>
      <Alert onDismiss={() => setShowAlert(false)} enableIcon variant="warning">
        <Text>
          <FormattedMessage
            id="ExportExcelLimitWarning.limitExceededMessage"
            defaultMessage="Your search query generated more than {limit} results. <strong>Only {limit} search results can be exported,</strong> please refine your search query to export results."
            description="Warning message when export limit is exceeded. Example: limit = '10000'"
            values={{
              limit: EXPORT_EXCEL_LIMIT,
              strong: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </Text>
      </Alert>
    </Box>
  ) : null;
};

export default ExportExcelLimitWarning;
